import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetIssuedCardEnabledRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetIssuedCardEnabledResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setIssuedCardEnabled = (request: SetIssuedCardEnabledRequest, options?: CashRequestOptions) =>
  post<SetIssuedCardEnabledRequest, SetIssuedCardEnabledResponse>('/2.0/cash/set-issued-card-enabled', request, {
    ...options,
    rejectOnError: true,
  })
